import React, { useState } from 'react';
import Header from '../../components/header';
import Card from '../../components/Card';
import ProgressBar from '../../components/ProgressBar/progressbar';
import { Listbox } from '@headlessui/react';
import { ChevronDownIcon, XCircleIcon } from '@heroicons/react/24/solid';
import Styles from './patchcenterStyle.module.scss';
import Sidebar from '../../components/sidebar/sidebar';

import { useNavigate } from 'react-router-dom';
import SoftwareTable from './softwareTable';
import SelectDevice from './selectDevice';

const selectDeviceRoute = () => {
  return (
    <div className="flex">
      <Sidebar></Sidebar>
      <div className=" flex-1" style={{ backgroundColor: 'rgb(7, 7, 7)' }}>
        <Header title="Select Devices" dropdown={2} />

        {/* <Card className="flex-1">

        </Card> */}
        <SelectDevice />
      </div>
    </div>
  );
};

export default selectDeviceRoute;
